<div class="flex-container flow-column full-height">
  <div class="flex-one">
    <div *ngIf="simProgress">
      <mat-progress-bar mode="determinate" [value]="(simProgress.percent * 100)"></mat-progress-bar>
      <div class="flex-container flow-column details-list"
           *ngIf="simProgress"
      >
        <span class="detail-item"
              i18n="Simulation details dialog percent@@simDetailsDialogPercent"
        >percent: {{(simProgress.percent * 100).toFixed(2)}}%</span>
        <span class="detail-item"
              i18n="Simulation details dialog processed@@simDetailsDialogProcessed"
        >processed: {{toNumWithCommas(simProgress.processed)}}</span>
        <span class="detail-item"
              i18n="Simulation details dialog processed@@simDetailsDialogValid"
        >valid recipes: {{toNumWithCommas(simProgress.valid)}}</span>
      </div>
    </div>
    <div *ngIf="!simProgress">
      <h3 i18n="Simulation details no data message@@simDetailsNoDetailsMessage"
      >no simulation data available</h3>
    </div>
  </div>
  <div class="flex-container button-section">
    <div class="">
      <div class="buttongroup confirm-button">
        <button mat-button
                class="button-width"
                i18n="Simulation details dialog confirm button@@simDetailsConfirmButton"
                (click)="close()"
        >confirm</button>
      </div>
    </div>
    <div class="">
      <div class="buttongroup confirm-button">
        <button mat-button
                class="button-width"
                matTooltip="if you think the simulation has failed, please try restarting it"
                i18n="Simulation details dialog cancel button@@simDetailsCancelButton"
                (click)="reSimulate()"
        >restart simulation</button>
      </div>
    </div>
  </div>
</div>
